import { Link } from 'react-router-dom';
import styles from './PageFooter.module.css';

/* `ref` is a plain prop in React 19 — callers measure the footer to work out
   how much room is left above it (see useFitRows).

   `note` is a line the page wants to sign off with, sat opposite the links: the
   trade copier prints its sample-data disclaimer there. */
function PageFooter({ ref, note }) {
  return (
    <div className={`${styles.footer} ${note ? styles.withNote : ''}`} ref={ref}>
      {note && <p className={styles.note}>{note}</p>}
      <div className={styles.links}>
        <Link to="/dashboard/terms" className={styles.link}>Terms</Link>
        <span className={styles.dot}>•</span>
        <Link to="/dashboard/privacy" className={styles.link}>Privacy</Link>
      </div>
    </div>
  );
}

export default PageFooter;
